// Polyfills for browser compatibility
// This file must be imported FIRST before any other modules

import { Buffer } from 'buffer';

// Make Buffer and process available globally for browser compatibility
// This must be done before any modules that depend on Node.js APIs are loaded
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.global = window.global || window;
  window.process = window.process || { env: {}, version: '', versions: {} };
}

if (typeof globalThis !== 'undefined') {
  globalThis.Buffer = Buffer;
  globalThis.global = globalThis.global || globalThis;
  globalThis.process = globalThis.process || { env: {}, version: '', versions: {} };
}

// Export for use in other modules
export { Buffer };

